import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Grid, Box, IconButton, Tooltip } from "@material-ui/core";
import { useStyles } from "./AssetNonTitled/AssetNonTitledFormStyles";
import { Edit, Save, AccountCircleOutlined } from "@material-ui/icons";
import { actions } from "./AssetReducer";
import useAssetProvider from "./useAssetProvider";

const AssetTruckBody = (props) => {
	const {
		asset,
		conditions,
		loadYearChoices,
		loadTruckBodyCategoryChoices,
		loadTruckBodyMakeChoices,
		loadTruckBodyModelChoices,
		loadTruckBodyConfigChoices,
		setTruckBodyAssetConfig,
		dispatch,
	} = props;
	const classes = useStyles();
	const { isReadOnly } = useAssetProvider();
	const classId = 8;
	const tooltipPlacement = "top-end";
	const tooltipEdit = "Change";
	const tooltipManual = "Manual";
	const tooltipSave = "Save";

	useEffect(() => {
		loadYearChoices();
	}, []);

	return (
		<Box>
			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="turck-body-year"
						label="Year"
						value={asset?.truck_body_year || "No Year"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_truck_body &&
						!conditions.isManualYear &&
						conditions.edit_truck_body &&
						conditions.yearChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-body-year-label">Override Year</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-year-select"
									labelId="override-body-year-label"
									value={asset.override_truck_body_year || ""}
									onChange={(e) => {
										loadTruckBodyCategoryChoices(e.target.value, classId);
									}}>
									{conditions.yearChoices &&
										conditions.yearChoices.map((year) => (
											<MenuItem key={year} value={year}>
												{year}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualYear ||
						conditions.yearChoices.length === 0 ||
						!conditions.edit_truck_body) && (
						<TextField
							style={{ width: "100%" }}
							id="override-body-year"
							label="Override Year"
							value={asset.override_truck_body_year || ""}
							margin="normal"
							disabled={isReadOnly || !conditions.isManualYear}
							onChange={(e) => {
								dispatch({
									type: actions.OVERRIDE_TRUCK_BODY_YEAR,
									payload: e.target.value,
								});
							}}
						/>
					)}
				</Grid>

				{!isReadOnly  &&
					conditions.edit_truck_body &&
					!conditions.searchVIN &&
					conditions.isYear && (
						<Grid item xs={2}>
							{conditions.yearChoices.length === 0 && !conditions.isManualYear && (
								<Tooltip title={tooltipEdit} placement={tooltipPlacement}>
									<IconButton
										onClick={() => {
											loadYearChoices();
										}}>
										<Edit />
									</IconButton>
								</Tooltip>
							)}

							{!conditions.isManualYear && conditions.yearChoices.length > 0 && (
								<Tooltip title={tooltipManual} placement={tooltipPlacement}>
									<IconButton
										onClick={() => {
											dispatch({
												type: actions.IS_MANUAL_YEAR,
												payload: true,
											});
										}}>
										<AccountCircleOutlined />
									</IconButton>
								</Tooltip>
							)}
							{conditions.isManualYear && (
								<Tooltip title={tooltipSave} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											loadTruckBodyCategoryChoices(
												asset.override_truck_body_year,
												classId
											);
										}}>
										<Save />
									</IconButton>
								</Tooltip>
							)}
						</Grid>
					)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="body-category"
						label="Body Category"
						value={asset?.pd_truck_body_category || "No Category"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_truck_body &&
						!conditions.isManualCategory &&
						conditions.truckBodyCategoryChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-category-label">Override Category</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-category-select"
									labelId="override-category-label"
									value={asset.pd_truck_body_override_category || ""}
									onChange={(e) => {
										loadTruckBodyMakeChoices(e.target.value, classId);
									}}>
									{conditions.truckBodyCategoryChoices &&
										conditions.truckBodyCategoryChoices.map((category) => (
											<MenuItem key={category.categoryId} value={category}>
												{category.categoryName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualCategory ||
						conditions.truckBodyCategoryChoices.length === 0 ||
						!conditions.edit_truck_body) && (
						<TextField
							style={{ width: "100%" }}
							id="override-body-category"
							label="Override Body Category"
							value={asset.pd_truck_body_override_category || ""}
							margin="normal"
							disabled={isReadOnly || !conditions.isManualCategory}
							onChange={(e) => {
								dispatch({
									type: actions.PD_OVERRIDE_TRUCK_BODY_CATEGORY,
									payload: {
										categoryId: e.target.value,
										categoryName: e.target.value,
									},
								});
							}}
						/>
					)}
				</Grid>
				{!isReadOnly && asset?.override_truck_body_year && 
					conditions.edit_truck_body &&
					!conditions.searchVIN &&
					conditions.isCategory && (
						<Grid item xs={2}>
							{conditions.truckBodyCategoryChoices.length === 0 &&
								!conditions.isManualCategory && (
									<Tooltip title={tooltipEdit} placement={tooltipPlacement}>
										<IconButton
											color="primary"
											onClick={() => {
												loadTruckBodyCategoryChoices("", classId);
											}}>
											<Edit />
										</IconButton>
									</Tooltip>
								)}

							
							{conditions.isManualCategory && asset.pd_truck_body_override_category && (
								<Tooltip title={tooltipSave} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											dispatch({
												type: actions.SAVE_TRUCK_CATEGORY,
											});
										}}>
										<Save />
									</IconButton>
								</Tooltip>
							)}
	
						</Grid>
					)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="body-make"
						label="Body Make"
						value={asset.make || "No Make"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_truck_body &&
						!conditions.isManualMake &&
						conditions.truckBodyMakeChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-make-label">Override Make</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-body-make-select"
									labelId="override-body-make-label"
									value={asset.override_truck_body_make || ""}
									onChange={(e) => {
										loadTruckBodyModelChoices(e.target.value, classId);
									}}>
									{conditions.truckBodyMakeChoices &&
										conditions.truckBodyMakeChoices.map((make) => (
											<MenuItem key={make.manufacturerId} value={make.manufacturerName}>
												{make.manufacturerName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualMake ||
						conditions.truckBodyMakeChoices.length === 0 ||
						!conditions.edit_truck_body) && (
						<TextField
							style={{ width: "100%" }}
							id="override-body-make"
							label="Override Body Make"
							value={asset.override_truck_body_make || ""}
							margin="normal"
							disabled={
								isReadOnly || !conditions.isManualMake || !conditions.edit_truck_body
							}
							onChange={(e) =>
								dispatch({
									type: actions.OVERRIDE_TRUCK_BODY_MAKE,
									payload: e.target.value,
								})
							}
						/>
					)}
				</Grid>
				{!isReadOnly && asset.pd_truck_body_override_category && conditions.edit_truck_body && !conditions.searchVIN && (
					<Grid item xs={2}>
						{conditions.truckBodyMakeChoices.length === 0 &&
							!conditions.isManualMake &&
							asset.pd_truck_body_override_categoryid && (
								<Tooltip title={tooltipEdit} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											loadTruckBodyMakeChoices(
												{
													categoryId: asset.pd_truck_body_override_categoryid,
													categoryName: asset.pd_truck_body_override_category,
												},
												classId
											);
										}}>
										<Edit />
									</IconButton>
								</Tooltip>
							)}

						{!conditions.isManualMake && conditions.isMake && (
							<Tooltip title={tooltipManual} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										dispatch({
											type: actions.IS_MANUAL_MAKE,
											payload: true,
										});
									}}>
									<AccountCircleOutlined />
								</IconButton>
							</Tooltip>
						)}

						{conditions.isManualMake && asset.override_truck_body_make && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										
										loadTruckBodyModelChoices(asset.override_truck_body_make, classId);
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="body-model"
						label="Body Model"
						value={asset.model || "No Model"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				{
					console.log("Check",conditions.isManualModel,conditions.truckBodyModelChoices.length)
				}
				<Grid item xs={5}>
					{!isReadOnly && 
						conditions.edit_truck_body &&
						!conditions.isManualModel &&
						conditions.truckBodyModelChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-model-label">Override Model</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-body-model-select"
									labelId="override-body-model-label"
									disabled={!asset.override_truck_body_make}
									value={asset.override_truck_body_model || ""}
									onChange={(e) => {
										loadTruckBodyConfigChoices(e.target.value, classId);
									}}>
									{conditions.truckBodyModelChoices &&
										conditions.truckBodyModelChoices.map((model) => (
											<MenuItem key={model.modelId} value={model.modelName}>
												{model.modelName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualModel ||
						conditions.truckBodyModelChoices.length === 0 ||
						!conditions.edit_truck_body) && (
						<TextField
							style={{ width: "100%" }}
							id="override-body-model"
							label="Override Body Model"
							value={asset.override_truck_body_model || ""}
							margin="normal"
							disabled={
								isReadOnly || !conditions.isManualModel || !conditions.edit_truck_body
							}
							onChange={(e) =>
								dispatch({
									type: actions.OVERRIDE_TRUCK_BODY_MODEL,
									payload: e.target.value,
								})
							}
						/>
					)}
				</Grid>
				{!isReadOnly && asset.override_truck_body_make && conditions.edit_truck_body && !conditions.searchVIN && (
					<Grid item xs={2}>
						{conditions.truckBodyModelChoices.length === 0 &&
							!conditions.isManualModel &&
							asset.pd_truck_body_override_category &&
							asset.override_truck_body_make && (
								<Tooltip title={tooltipEdit} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											loadTruckBodyModelChoices(asset.override_truck_body_make, classId);
										}}>
										<Edit />
									</IconButton>
								</Tooltip>
							)}

						{!conditions.isManualModel && conditions.isModel && (
							<Tooltip title={tooltipManual} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										dispatch({
											type: actions.IS_MANUAL_MODEL,
											payload: true,
										});
									}}>
									<AccountCircleOutlined />
								</IconButton>
							</Tooltip>
						)}

						{conditions.isManualModel && asset.override_truck_body_model && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										
										loadTruckBodyConfigChoices(asset.override_truck_body_model, classId);
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="body-config"
						label="Body Configuration"
						value={asset?.pd_truck_body_configuration || "No Body Configuration"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_truck_body &&
						!conditions.isManualConfig &&
						conditions.truckBodyConfigChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-body-config-label">
									Override Body Configuration
								</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-body-config-select"
									labelId="override-body-config-label"
									value={asset?.pd_truck_body_override_configurationid || ""}
									onChange={(e) => {
										setTruckBodyAssetConfig(e.target.value);
									}}>
									{conditions.truckBodyConfigChoices &&
										conditions.truckBodyConfigChoices.map((config) => (
											<MenuItem key={config.configurationId} value={config}>
												{config.specs.description}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualConfig ||
						conditions.truckBodyConfigChoices.length === 0 ||
						!conditions.edit_truck_body) && (
						<TextField
							style={{ width: "100%" }}
							id="override-body-config"
							label="Body Configuration"
							value={asset?.override_truck_body_description || ""}
							margin="normal"
							disabled={
								isReadOnly || !conditions.isManualConfig || !conditions.edit_truck_body
							}
							onChange={(e) => {
								dispatch({
									type: actions.SET_OVERRIDE_TRUCK_BODY_DESCRIPTION,
									payload: e.target.value,
								});
							}}
						/>
					)}
				</Grid>
				{!isReadOnly && asset.override_truck_body_model && conditions.edit_truck_body && (
					<Grid item xs={2}>
						{conditions.truckBodyConfigChoices.length === 0 &&
							!conditions.isManualConfig &&
							asset.pd_truck_body_override_categoryid &&
							asset.override_truck_body_make &&
							asset.override_truck_body_model && (
								<Tooltip title={tooltipEdit} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											loadTruckBodyConfigChoices(asset.override_truck_body_model, classId);
										}}>
										<Edit />
									</IconButton>
								</Tooltip>
							)}

						{conditions.truckBodyConfigChoices.length > 0 &&
							!conditions.isManualConfig && (
								<Tooltip title={tooltipManual} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											dispatch({
												type: actions.IS_MANUAL_CONFIG,
												payload: true,
											});
										}}>
										<AccountCircleOutlined />
									</IconButton>
								</Tooltip>
							)}

						{conditions.isManualConfig && asset.override_truck_body_description && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										dispatch({
											type: actions.RESET_TRUCK_BODY,
										});
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>
		</Box>
	);
};

export default AssetTruckBody;
